import Avatar from "@mui/material/Avatar"
import Skeleton from "@mui/material/Skeleton"
import { forwardRef } from "react"

function _CandidateAvatar(
  {
    candidate,
    size = "128px",
    fontSize = "3em",
    isLoading = false,
    rootSX = {},
    ...props
  },
  ref
) {
  return isLoading ? (
    <Skeleton variant="circular" width={size} height={size} />
  ) : (
    <Avatar
      ref={ref}
      src={candidate.profile_image}
      sx={{ width: size, height: size, fontSize, ...rootSX }}
      {...props}
    >
      {candidate.profile_image ? null : nameInitials(candidate.candidate_name)}
    </Avatar>
  )
}

function nameInitials(name: String) {
  const names = (name || "- -").split(" ")
  const initials = names.map((name) => name[0])
  initials.splice(2)
  return initials.join("")
}

export default forwardRef(_CandidateAvatar)
